import React from 'react'
import { useNavigate } from 'react-router-dom'

import Description from '../../../components/molecules/Description'
import Copy from '../../../components/atoms/Copy'
import PageLoading from '../../../components/organisms/PageLoading'
import Button from '../../../components/atoms/Button'
import { TokenDetailRes } from '../../../api/token/response'
import { weiToEther } from '../../../utils/dataFormat'

type Props = {
  loading: boolean
  tokenDetails: TokenDetailRes
}

function OverView({ loading, tokenDetails }: Props) {
  const navigate = useNavigate()
  const onClickContract = () => navigate(`/account/${tokenDetails.address}`)

  return (
    <>
      <PageLoading loading={loading} />
      <Description
        dataSource={[
          { title: 'Name', desc: tokenDetails.name },
          { title: 'Symbol', desc: tokenDetails.symbol },
          {
            title: 'Contract',
            desc: (
              <>
                <Button buttonTheme="defaultBlue" text={tokenDetails.address} onClick={onClickContract} />
                <Copy text={tokenDetails.address} />
              </>
            ),
          },
          {
            title: 'Max Total Supply',
            desc: (
              <>
                {tokenDetails.totalSupply ? weiToEther(tokenDetails.totalSupply) : ``} {tokenDetails.symbol}
              </>
            ),
          },
          { title: 'Total transfers', desc: tokenDetails.totalTransfer },

          {
            title: 'Official site',
            desc: (
              <>
                <Button buttonTheme="defaultBlue" text={tokenDetails.officialSite} link={tokenDetails.officialSite} />
                <Copy text={tokenDetails.officialSite} />
              </>
            ),
          },
        ]}
      />
    </>
  )
}

export default OverView
